import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { IconWrapped } from '@PipelineDeals/shared-react-components'

import { BusinessCard, DEAL_TYPE, PERSON_TYPE, COMPANY_TYPE } from 'components/BusinessCard'

export const BusinessCardButton = ({ itemId, item, type, wrapperClassName = 'centered' }) => {
  const style = window.User.external ? { cursor: 'default' } : {}
  const id = `${type}_business_card_button_${itemId}`
  const [showBusinessCard, setShowBusinessCard] = useState(false)
  const iconType = type === DEAL_TYPE && item && item?.person_ids?.length > 1 ? 'fa-users' : 'fa-user'

  return (
    <div className={wrapperClassName}>
      <a
        onClick={() => {
          window.trackableEvent.listViews.viewContactCardFromListView()
          setShowBusinessCard(true)
        }}
        style={style}
        id={id}
      >
        <IconWrapped icon={iconType} />
        {showBusinessCard &&
          <BusinessCard
            type={type}
            itemId={itemId}
            element={document.getElementById(id)}
            onClose={() => setShowBusinessCard(false)}
            showPeopleCarousel={type === DEAL_TYPE}
          />}
      </a>
    </div>
  )
}

BusinessCardButton.propTypes = {
  itemId: PropTypes.number.isRequired,
  item: PropTypes.object,
  type: PropTypes.oneOf([DEAL_TYPE, PERSON_TYPE, COMPANY_TYPE]),
  wrapperClassName: PropTypes.string
}
